import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OccEndpointsService } from '@spartacus/core';
import { Udxb2bExpressPassProduct } from '../features/model';

@Injectable({
  providedIn: 'root',
})
export class UdxExpressPassAttractionsService {
  constructor(protected _http: HttpClient, protected _occEndpoints: OccEndpointsService) {}

  getAttractions(selectedDate: any, selectedQty: number, baseProductCode: string) {
    let queryParams = new HttpParams();
    queryParams = queryParams.append('selectedDate', String(selectedDate));
    queryParams = queryParams.append('selectedQty', String(selectedQty));
    queryParams = queryParams.append('baseProductCode', String(baseProductCode));
    return this._http.get<Udxb2bExpressPassProduct>(this._occEndpoints.buildUrl('getAttractions'), {
      params: queryParams,
    });
    // return this._http.get<Udxb2bExpressPassProduct>('assets/AttractionsResponse.json');
  }
}
